import { useCallback, useEffect, useState } from "react";

const fsEl = () => document.fullscreenElement || document.webkitFullscreenElement;

// Fullscreen for one element; falls back to a fixed full-window view where the API is missing (iPhone Safari). Esc exits both.
export const useFullscreen = (ref) => {
  const [native, setNative] = useState(false);
  const [css, setCss] = useState(false);
  useEffect(() => {
    const sync = () => setNative(Boolean(fsEl()) && fsEl() === ref.current);
    document.addEventListener("fullscreenchange", sync);
    document.addEventListener("webkitfullscreenchange", sync);
    return () => { document.removeEventListener("fullscreenchange", sync); document.removeEventListener("webkitfullscreenchange", sync); };
  }, [ref]);
  useEffect(() => {
    if (!css) return undefined;
    const esc = (e) => { if (e.key === "Escape") setCss(false); };
    window.addEventListener("keydown", esc);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", esc); document.body.style.overflow = ""; };
  }, [css]);
  const exit = useCallback(() => {
    setCss(false);
    if (fsEl()) (document.exitFullscreen || document.webkitExitFullscreen)?.call(document)?.catch?.(() => {});
  }, []);
  const toggle = useCallback(() => {
    if (native || css) { exit(); return; }
    const el = ref.current;
    const req = el?.requestFullscreen || el?.webkitRequestFullscreen;
    if (!req) { setCss(true); return; }
    Promise.resolve(req.call(el)).catch(() => setCss(true));
  }, [native, css, exit, ref]);
  return { full: native || css, css, toggle, exit };
};
